import Request from './util/Request'
export const tenantsRequest = new Request(
  // host
  `https://${process.env.LOCAL_BACKEND || process.env.TENANTS_API_HOST}`,
  '/tdms/v1/tenants',
  // options
  {
    credentials: 'include',
    redirect: 'manual',
  },
  true,
)

export const memberLookupRequest = new Request(
  // host
  process.env.TENANTS_API_HOST,
  // path
  '/tdms/v1/users/lookup',
  // options
  {
    credentials: 'include',
    redirect: 'manual',
  },
)
